import React from "react";
import "./footer.css";
import { useNavigate } from "react-router-dom";
import useReRouteHook from "../../assets/hooks/useReRouteHook";
interface Link {
  text: string;
  href: string;
  isLocalPage?: string;
}

interface SubSection {
  title: string;
  links: Link[];
}

interface FooterColumnProps {
  title: string;
  links: Link[];
  subSections?: SubSection[];
}

const FooterColumn: React.FC<FooterColumnProps> = ({ title, links, subSections }) => {
  const { reRouteButtonRenderer } = useReRouteHook();
  return (
    <div className="footer-column">
      <h6 className="fs-14 in_semi lh-22 text-uppercase d-xl-none mb-2">{title}</h6>
      <h6 className="fs-14 in_semi lh-22 d-none d-xl-block">{title}</h6>
      <ul className="list-unstyled mt-3 footer-column-list">
        {links.map((link, index) => {
          const isLast = index === links.length - 1;
          const pipeClass = !isLast ? "footer-link-pipe-mobile" : "";
          return (
            <li className="mb-1 footer-column-item" key={index}>
              {link?.isLocalPage ? (
                reRouteButtonRenderer({
                  url: link.isLocalPage,
                  classes: `decoration fs-12 in_reg lh-14 footer-link p-0 ${pipeClass}`,
                  nameText: link.text,
                })
              ) : (
                <a
                  href={link.href}
                  className={`decoration fs-12 in_reg lh-14 footer-link ${pipeClass}`}
                  target={["Fund Transfer", "PMS UPI Handle"].includes(link.text) ? "_blank" : undefined}
                  rel={["Fund Transfer", "PMS UPI Handle"].includes(link.text) ? "noopener noreferrer" : undefined}
                >
                  {link.text}
                </a>
              )}
            </li>
          );
        })}
      </ul>
      {subSections &&
        subSections.map((subSection, index) => (
          <div key={index} className="mt-4">
            <h6 className="fs-14 in_semi lh-22 text-uppercase d-xl-none mb-2">{subSection.title}</h6>
            <h6 className="fs-14 in_semi lh-22 d-none d-xl-block">{subSection.title}</h6>
            <ul className="list-unstyled mt-3 footer-column-list">
              {subSection.links.map((link, subIndex) => {
                const isLastSub = subIndex === subSection.links.length - 1;
                const pipeClassSub = !isLastSub ? "footer-link-pipe-mobile" : "";
                return (
                  <li className="mb-0 footer-column-item" key={subIndex}>
                    <a
                      href={link.href}
                      className={`decoration fs-12 in_reg lh-14 footer-link ${pipeClassSub}`}
                    >
                      {link.text}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
    </div>
  );
};

export default FooterColumn;
